import {Component, OnInit} from '@angular/core';

import {SafeResourceUrl, DomSanitizer, Title, SafeHtml} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {HELP_CONTENTS_STYLE} from '../common/constants';
import {HttpClient} from '@angular/common/http';
import {forkJoinDefaultIfEmpty} from '../common/observable.utils';
import {Observable} from 'rxjs';
import {HELP_LINK_CONTENTS_BASE_URL, HELP_CONTENT_TYPE, NESTED_HELP_ITEMS} from '../common/constants';

@Component({
    selector: 'nlrp-help',
    imports: [],
    templateUrl: './help.component.html',
    styleUrl: './help.component.scss'
})
export class HelpComponent implements OnInit {
    safeUrl: SafeResourceUrl | undefined;

    helpContent: SafeHtml | null = null;

    parentHelpContent: SafeHtml | null = null;

    constructionParentContentLinkUrl: string = HELP_LINK_CONTENTS_BASE_URL + 'construction-tools-help.html';

    annotationParentContentLinkUrl: string = HELP_LINK_CONTENTS_BASE_URL + 'annotation-tools-help.html';

    enlargementParentContentLinkUrl: string = HELP_LINK_CONTENTS_BASE_URL + 'enlargement-help.html';

    attributeParentContentLinkUrl: string = HELP_LINK_CONTENTS_BASE_URL + 'attribute-viewer-help.html';

    attributeColumnSubParentContentLinkUrl: string = HELP_LINK_CONTENTS_BASE_URL + 'attribute-viewer-column-chooser-help.html';

    attributeFilterSubParentContentLinkUrl: string = HELP_LINK_CONTENTS_BASE_URL + 'attribute-viewer-filter-features-help.html';

    attributeEditSubParentContentLinkUrl: string = HELP_LINK_CONTENTS_BASE_URL + 'attribute-editor-help.html';

    parentContentEnabled: boolean = false;

    subParentContentEnabled: boolean = false;

    mainContentRequired: boolean = true;

    constructor(
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private titleService: Title,
        private http: HttpClient
    ) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            const helpHtmlPath = params['url'];
            const helpTitle = params['title'];
            const helpCSSPath = HELP_CONTENTS_STYLE;

            if (NESTED_HELP_ITEMS.some(item => helpHtmlPath.includes(item))) {
                this.parentContentEnabled = true;

                if (helpHtmlPath.includes('annotation')) {
                    this.injectTitleStyles(
                        this.getHelpContent(this.annotationParentContentLinkUrl),
                        this.getHelpContent(helpCSSPath),
                        HELP_CONTENT_TYPE.PARENT
                    );
                } else if (helpHtmlPath.includes('construction')) {
                    this.injectTitleStyles(
                        this.getHelpContent(this.constructionParentContentLinkUrl),
                        this.getHelpContent(helpCSSPath),
                        HELP_CONTENT_TYPE.PARENT
                    );
                } else if (helpHtmlPath.includes('enlargement')) {
                    this.injectTitleStyles(
                        this.getHelpContent(this.enlargementParentContentLinkUrl),
                        this.getHelpContent(helpCSSPath),
                        HELP_CONTENT_TYPE.PARENT
                    );
                } else if (helpHtmlPath.includes('attribute')) {
                    this.injectTitleStyles(
                        this.getHelpContent(this.attributeParentContentLinkUrl),
                        this.getHelpContent(helpCSSPath),
                        HELP_CONTENT_TYPE.PARENT
                    );

                    if (helpHtmlPath.includes('attribute-editor')) {
                        this.subParentContentEnabled = true;
                        this.injectTitleStyles(
                            this.getHelpContent(this.attributeEditSubParentContentLinkUrl),
                            this.getHelpContent(helpCSSPath),
                            HELP_CONTENT_TYPE.SUB_PARENT
                        );
                    } else if (helpHtmlPath.includes('column-chooser') || helpHtmlPath.includes('feature-filter')) {
                        this.subParentContentEnabled = true;
                        let observable: Observable<any>;

                        observable = helpHtmlPath.includes('column-chooser')
                            ? this.getHelpContent(this.attributeColumnSubParentContentLinkUrl)
                            : this.getHelpContent(this.attributeFilterSubParentContentLinkUrl);

                        this.injectTitleStyles(observable, this.getHelpContent(helpCSSPath), HELP_CONTENT_TYPE.SUB_PARENT, helpTitle);
                        this.mainContentRequired = false;
                    }
                }
            }

            if (this.mainContentRequired)
                this.injectTitleStyles(this.getHelpContent(helpHtmlPath), this.getHelpContent(helpCSSPath), HELP_CONTENT_TYPE.MAIN, helpTitle);
        });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.route.snapshot.queryParamMap.get('url')) {
                const element = document.getElementById('helpContent');
                if (element) element.scrollIntoView({behavior: 'auto'});
            }
        }, 100);
    }

    private injectTitleStyles(html: Observable<any>, css?: Observable<any>, contentType?: string, title?: string) {
        if (title) this.titleService.setTitle(title);
        this.processHtml(html, css, contentType);
    }

    private processHtml(html: Observable<any>, css: Observable<any>, targetProperty: string) {
        forkJoinDefaultIfEmpty([html, css]).subscribe({
            next: ([html, css]) => {
                this[targetProperty] = this.getStyledHtml(html, css);
            },
            error: err => {
                console.error('Error loading dynamic help content:', err);
            }
        });
    }

    private getHelpContent(path: string) {
        return this.http.get(path, {responseType: 'text'});
    }

    private getStyledHtml(html: string, css: string) {
        const styledHtml = html.includes(`</head>`) ? html.replace('</head>', `<style>${css}</style></head>`) : `<style>${css}</style>` + html;
        return this.sanitizer.bypassSecurityTrustHtml(styledHtml);
    }
}
